module.exports = __webpack_public_path__ + "media/images/organization-icon-95fc51f15b5d63adbfd1454fd9fcb17d.svg";